export default "__VITE_ASSET__Cl9sAbn8__"